import { render, staticRenderFns } from "./footer.vue?vue&type=template&id=ea927134&scoped=true&"
var script = {}
import style0 from "./footer.vue?vue&type=style&index=0&id=ea927134&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea927134",
  null
  
)

export default component.exports